<template>
  <div style="padding:10px">
    <back />
    <van-form @submit="onSave" autocomplete="off">
      <div class="whiteBg">
        <van-field
          v-model="originInfo.myName"
          name="姓名"
          label="姓名"
          maxlength="6"
          placeholder="请填写真实姓名"
          label-width="5em"
          :rules="[{ required: true }]"
        ></van-field>
        <van-field
          v-model="originInfo.phone"
          name="手机号"
          label="手机号"
          maxlength="11"
          placeholder="请填写手机号"
          label-width="5em"
          :rules="
            originInfo.phone
              ? [
                  {
                    pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                    message: '请输入正确的手机号'
                  }
                ]
              : [
                  {
                    pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/
                  }
                ]
          "
        ></van-field>
        <!-- <div class="flex"> -->
        <van-field
          readonly
          clickable
          name="area"
          :value="value"
          label="地区选择"
          label-width="5em"
          placeholder="请选择省市区"
          :rules="[{ required: true }]"
          @click="setPickerDefault"
        />
        <!-- <div class="icon-location" @click="getLocation()">
            <van-icon name="location" />
          </div>
        </div> -->
        <van-popup v-model="showArea" position="bottom">
          <van-picker
            show-toolbar
            title="选择地区"
            ref="areaPicker"
            value-key="areaName"
            :columns="areaList"
            @change="setArea"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
        <van-field
          v-model="originInfo.address"
          rows="2"
          autosize
          label="详细地址"
          type="textarea"
          maxlength="50"
          label-width="5em"
          placeholder="请填写详细地址，如街道、楼牌号等"
          :rules="[{ required: true }]"
        />
      </div>
      <div style="padding:0 10px;margin:10px 0">
        <van-button
          round
          block
          color="#a30015"
          native-type="submit"
          :disabled="btnDisabled"
          >保存并使用</van-button
        >
      </div>
    </van-form>
    <div style="padding:0 10px" v-if="edit">
      <van-button round block :disabled="btnDisabled" @click.stop="handleDelete"
        >删除</van-button
      >
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
// import { areaList } from '@vant/area-data'
import Back from '@/components/back'
export default {
  components: {
    Back
  },
  data() {
    return {
      originInfo: {},
      address: {},
      areaList: [],
      column1: [],
      column2: [],
      column3: [],
      value: '',
      edit: false,
      showArea: false,
      flag: false,
      selectArea: {},
      btnDisabled: false
    }
  },
  created() {
    if (this.$route.query.addressId) {
      document.title = '编辑收件人'
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = '../../../public/favicon.ico'
      document.body.appendChild(iframe)
      iframe.addEventListener('load', function() {
        setTimeout(function() {
          iframe.remove()
        }, 0)
      })

      this.edit = true
      this.$api.getUserAddress(this.$route.query).then(res => {
        if (res.code === 0) {
          this.originInfo = res.data
          if (this.originInfo.province) {
            this.value =
              this.originInfo.province +
              '/' +
              this.originInfo.city +
              '/' +
              this.originInfo.district
          }
        }
      })
    }

    this.setAreaList()
  },
  methods: {
    onConfirm(values) {
      if (
        this.selectArea.provinceCode.toString().slice(0, 2) ===
          this.selectArea.cityCode.toString().slice(0, 2) &&
        this.selectArea.cityCode.toString().slice(0, 4) ===
          this.selectArea.districtCode.toString().slice(0, 4)
      ) {
        this.originInfo.province = values[0]
        this.originInfo.city = values[1]
        this.originInfo.district = values[2]
        this.value = values.join('/')
        this.showArea = false
      } else {
        this.$toast.fail('选择的省市区不匹配')
      }
    },
    onSave() {
      this.btnDisabled = true
      this.splitValue()
      // const that = this
      if (!this.edit) {
        let params = Object.assign({ type: 1, defaultFlag: 0 }, this.originInfo)
        if (this.flag) {
          params = Object.assign(params, this.selectArea)
        }
        let data = this.$Base64.encode(JSON.stringify(params))
        this.$api
          .addUserAddress(data)
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.$store.commit(
                    'set_addresseeInfo',
                    Object.assign(res.data, this.originInfo, this.selectArea)
                  )
                  // this.btnDisabled = false
                  if (this.$route.query.path === 'go') {
                    this.$router.go(-1)
                    // window.history.go(-1)
                  } else {
                    this.$router.go(-2)
                    // window.history.go(-2)
                  }
                }
              })
            }
          })
          .catch(() => {
            this.btnDisabled = false
          })
      } else {
        let params = this.originInfo
        if (this.flag) {
          params = Object.assign(params, this.selectArea)
        }
        console.log('params', params)
        let data = this.$Base64.encode(JSON.stringify(params))
        this.$api
          .editUserAddress(data)
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.$store.commit(
                    'set_addresseeInfo',
                    Object.assign(this.originInfo, this.selectArea)
                  )
                  // this.btnDisabled = false
                  if (this.$route.query.path === 'go') {
                    this.$router.go(-1)
                    // window.history.go(-1)
                  } else {
                    this.$router.go(-2)
                    // window.history.go(-2)
                  }
                }
              })
            }
          })
          .catch(() => {
            this.btnDisabled = false
          })
      }
    },
    splitValue() {
      const array = this.value.split('/')
      this.address.province = array[0]
      this.address.city = array[1]
      this.address.district = array[2]
      this.originInfo = Object.assign(this.originInfo, this.address)
    },
    handleDelete() {
      Dialog.confirm({
        title: '提示',
        message: '确认删除？'
      })
        .then(() => {
          // on confirm
          this.btnDisabled = true
          this.$api
            .deleteUserAddress({ addressId: this.originInfo.addressId })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  message: '删除成功',
                  type: 'success',
                  duration: 1000,
                  onClose: () => {
                    if (this.$store.state.addresseeInfo) {
                      if (
                        this.originInfo.addressId ===
                        this.$store.state.addresseeInfo.addressId
                      ) {
                        this.$store.commit('set_addresseeInfo', null)
                      }
                    }
                    this.btnDisabled = false
                    this.$router.go(-1)
                    // window.history.go(-1)
                  }
                })
              }
            })
            .catch(() => {
              this.btnDisabled = false
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    getLocation() {
      console.log('获取定位')
    },
    setAreaList() {
      this.$api.getAreaList(0).then(res => {
        this.column1 = res
        this.selectArea.provinceCode = this.column1[0].areaId
        this.$api.getAreaList(this.column1[0].areaId).then(res => {
          this.column1[0].children = res
          this.selectArea.cityCode = this.column1[0].children[0].areaId
          this.$api
            .getAreaList(this.column1[0].children[0].areaId)
            .then(res => {
              this.column1[0].children[0].children = res
              this.selectArea.districtCode = this.column1[0].children[0].children[0].areaId
              this.areaList = this.column1.slice(0)
            })
        })
      })
    },
    // 改变picker时
    setArea(picker, value, index) {
      // console.log(index)
      switch (index) {
        case 0: {
          const i = picker.getColumnIndex(index)
          this.selectArea.provinceCode = this.column1[i].areaId
          this.$api.getAreaList(this.column1[i].areaId).then(res => {
            this.column2 = res
            picker.setColumnValues(1, this.column2)
            this.selectArea.cityCode = this.column2[0].areaId

            // 澳门
            if (this.selectArea.provinceCode === 820000) {
              this.column3 = []
              this.column3.push(JSON.parse(JSON.stringify(this.column2[0])))
              this.column2[0].children = this.column3
              this.areaList[i].children = this.column2.slice(0)
              picker.setColumnValues(2, this.column3)
              this.selectArea.districtCode = this.column3[0].areaId
              return
            }

            this.$api.getAreaList(this.column2[0].areaId).then(res => {
              this.column3 = res
              this.column2[0].children = this.column3
              this.areaList[i].children = this.column2.slice(0)
              picker.setColumnValues(2, this.column3)
              this.selectArea.districtCode = this.column3[0].areaId
            })
          })

          break
        }
        case 1: {
          const i = picker.getColumnIndex(index)
          this.selectArea.cityCode = this.column2[i].areaId

          // 澳门
          if (this.selectArea.provinceCode === 820000) {
            this.column3 = []
            this.column3.push(JSON.parse(JSON.stringify(this.column2[i])))
            this.column2[i].children = this.column3
            picker.setColumnValues(2, this.column3)
            this.selectArea.districtCode = this.column3[0].areaId
            return
          }

          this.$api.getAreaList(this.column2[i].areaId).then(res => {
            this.column3 = res
            this.column2[i].children = this.column3
            picker.setColumnValues(2, this.column3)
            this.selectArea.districtCode = this.column3[0].areaId
          })
          break
        }
        case 2: {
          const i = picker.getColumnIndex(index)
          this.selectArea.districtCode = this.column3[i].areaId
          break
        }
      }
    },
    setPickerDefault() {
      this.showArea = true
      this.flag = true
      this.$nextTick(() => {
        for (const i in this.column1) {
          if (this.column1[i].areaId === Number(this.originInfo.provinceCode)) {
            this.$refs.areaPicker.setColumnIndex(0, i)
            this.selectArea.provinceCode = Number(this.originInfo.provinceCode)

            this.$api.getAreaList(this.column1[i].areaId).then(res => {
              this.column2 = res
              this.column1[i].children = this.column2
              this.$refs.areaPicker.setColumnValues(1, this.column2)
              for (const j in this.column2) {
                if (
                  this.column2[j].areaId === Number(this.originInfo.cityCode)
                ) {
                  this.$refs.areaPicker.setColumnIndex(1, j)
                  this.selectArea.cityCode = Number(this.originInfo.cityCode)

                  // 澳门
                  if (this.selectArea.provinceCode === 820000) {
                    this.column3 = []
                    this.column3.push(
                      JSON.parse(JSON.stringify(this.column2[j]))
                    )
                    this.column2[j].children = this.column3
                    this.$refs.areaPicker.setColumnValues(2, this.column3)
                    this.selectArea.districtCode = this.column3[0].areaId
                    return
                  }

                  this.$api.getAreaList(this.column2[j].areaId).then(res => {
                    this.column3 = res
                    this.column2[j].children = this.column3
                    this.$refs.areaPicker.setColumnValues(2, this.column3)
                    for (const m in this.column3) {
                      if (
                        this.column3[m].areaId ===
                        Number(this.originInfo.districtCode)
                      ) {
                        this.$refs.areaPicker.setColumnIndex(2, m)
                        this.selectArea.districtCode = Number(
                          this.originInfo.districtCode
                        )
                        break
                      }
                    }
                  })
                  break
                }
              }
            })
            break
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.icon-location {
  padding-right: 5vw;
  .van-icon {
    font-size: 20px !important;
  }
}
</style>
